<template>
    <div class="card cardServico" :style="backgroundAtendido()" v-if="verificaTipoServico">
      <div class="card-body" :style="backgroundColorSelected">
        <div class="row">
          <div class="col-1 col-lg-1 text-left striped-sm">
            <input type="checkbox"
              :id="this.item.item.nr_sequencial"
              :disabled="itemAtendido"
              class="checkServicos"
              v-model="checkServico"
              @click="$emit('arrayServicos', item.item.nr_sequencial), backgroudSelected()"
            />            
          </div>
          <div class="col-8 col-lg-10 text-left ">
            <strong>{{ descricaoItem }}</strong>
          </div>
          <!-- <div class="col-1 col-lg-1">
            <button class="btn btn-danger" @click="excluirServico(item.nr_sequencial)">X</button>
          </div> -->
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    item: {},
    os: {},
    disabled: { type: Boolean, default: false },
    initAt: {}
  },
  data() {
    return {
      cod_item: '',
      disabledPeca: '',
      quantidade: 0,
      checkServico: [],
      backgroundColorSelected: 'background-image: linear-gradient(45deg, rgb(23 113 116 / 0%), rgb(108 191 101 / 0%)) !important;'
    }
  },
  computed: {
    verificaTipoServico() {
      try {
        if(this.item.item.tipo.nr_sequencial == 3) {
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },
    itemAtendido() {
      if(this.item.item_atendido){
        this.checkServico = true
      }
      return this.item.item_atendido
    },
    descricaoTipo() {
      if (this.item && this.item.item && this.item.item.tipo) {
        return this.item.item.tipo.ds_tipoitem
      }

      return ''
    },
    descricaoItem() {
      var descricao = ''

      // if (this.descricaoTipo.length) {
      //   descricao = this.descricaoTipo + ' | '
      // }

      if (this.item.item) {
        descricao += this.item.item.ds_item
      }

      if (!this.isExecutavel && this.item.estoque) {
        descricao += ` — ${this.item.estoque.ds_codigoitem}`
      }

      return descricao
    },

  },
  created() {
    this.quantidade = parseFloat(this.item.qt_quantidade)
  },
  methods: {
    backgroudSelected(){
      const checkServico = document.getElementById(this.item.item.nr_sequencial)
      if(checkServico.checked){
        this.backgroundColorSelected = 'background-image: linear-gradient(45deg, #177174, #6cbf65)!important; color: #fff!important;'
      } else {
        this.backgroundColorSelected = 'background-image: linear-gradient(45deg, rgb(23 113 116 / 0%), rgb(108 191 101 / 0%))!important;'
      }
    },

    backgroundAtendido() {
      if(this.itemAtendido) {
        return 'background-image: linear-gradient(45deg, #177174, #6cbf65)!important; color: #fff!important'
      }

      return 'backgroud: transparent'
    },
    excluirServico(item){

      this.$swal.fire({
        title: 'Exlcuir servico?',
        text: `Deseja realmente excluir este serviço da OS?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar'
      }).then(result => {
        if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {

          const filial = this.$store.getters['filial/filial']

          const nr_seq_clifor = filial.tecnicoId

          this.$store
              .dispatch('osItem/delete', { nrSeqOs: this.$route.params.id, nrSequencial: item, nrSeqClifor: nr_seq_clifor }).then(response => {
                this.$store.dispatch('osItem/fetchFromApiPreventiva', { nrSeqOs: this.$route.params.id })
                this.$emit('limparArrayServicos')
                const allCheckBox = document.querySelectorAll('.checkServicos')

                allCheckBox.forEach(checkBox => {
                  checkBox.checked = false
                })
                  this.disabledPeca = false
                  this.$swal.fire({
                      title: 'Sucesso',
                      text: 'Item excluído com sucesso!',
                      icon: 'success'
                  })
              }).catch(error => {
                  console.log(error)
              })

          // this.$destroy();
          // this.$el.parentNode.removeChild(this.$el);
         
        }
      }).catch((error) => {
        console.log(error)
      })

    },
    registrarPeca() {
      const data = {
        nr_os: this.$route.params.id,
        nr_sequencial: this.item.nr_sequencial,
        quantidade: parseFloat(this.quantidade)
      }

      this.$store
        .dispatch('osItem/updatePeca', { data: data }).then(response => {
          this.disabledPeca = true
          this.$swal.fire({
            title: 'Sucesso',
            text: 'Item registrado com sucesso!',
            icon: 'success'
          })
        })
        .catch(error => {
          console.log(error)
          this.$swal.fire({
            title: 'Oops!',
            text: 'Falha ao registrar o item. Tente novamente.',
            icon: 'error'
          })
        })
    },

    reloadOS() {
      return this.$store.dispatch('os/getDetails', {
        nrSequencial: this.$route.params.id
      })
    }
  }
}
</script>
<style scoped>
input[type=checkbox] {
  transform: scale(1.5)!important;
}
.card-body {
  border-radius: 25px;
  transition: 0.3s;
}
</style>